import { render, staticRenderFns } from "./auction-program-header.vue?vue&type=template&id=263bf2e2&"
import script from "./auction-program-header.vue?vue&type=script&lang=js&"
export * from "./auction-program-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports